import { Component } from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import AppContainer from 'common/containers/AppContainer/AppContainer';
import DeprecatedStylesContainer from '../components/common/Layout/DeprecatedStylesContainer/DeprecatedStylesContainer';
import { SessionTunnel } from 'common/util/SessionTunnel';
import { getAuthCredentials } from 'common/util/auth-storage';
import UserRegistration from 'main/components/UserRegistration';
import CreateBinder from 'overview/containers/CreateBinder/CreateBinder';
import QueryFiles from 'overview/containers/QueryFiles/QueryFiles';
import DocumentView from 'part11/containers/DocumentView/DocumentView';
import DocumentSigning from 'part11/containers/DocumentSigning/DocumentSigning';
import {
    BinderView,
    Details,
    Files,
    BinderSetup,
    UsersConfiguration
} from 'binder/containers';



import Binder from 'binder/components/Binder/Binder';
import DelegationOfAuthorityV2 from '../pages/delegationOfAuthority/v2/containers/DelegationOfAuthorityV2';
import InstitutionalAdminOverview from 'institutionalAdmin/containers/Overview/Overview';
import Users from 'part11/containers/Users/Users';
import User from 'part11/containers/User/User';
import CreateUser from 'part11/components/CreateUser/CreateUser';
import Groups from 'part11/containers/Groups/Groups';
import Group from 'part11/containers/Group/InstitutionalAdmin/Group';
import RoleManagement from 'part11/containers/RoleManagement/RoleManagement';
import RoleContent from 'part11/containers/RoleManagement/RoleContent';

import ExternalUsers from 'binder/components/ExternalUsers/ExternalUsers';
import Permissions from 'pages/permissions/containers';
import StudyPermissions from 'pages/permissions/containers/StudyPermissions';
import DataSourceList from '../pages/dataSource/containers/DataSourceList';
import DataSourceManagement from '../pages/dataSource/containers/DataSourceContainer';

// import BinderTask from '../pages/binder/BinderTask/BinderTask';
import BinderTaskV2 from 'pages/binder/BinderTask/BinderTaskV2';
import { IncompleteTasks } from 'pages/binder/BinderTask/IncompleteTasks';
import { CompletedTasks } from 'pages/binder/BinderTask/CompletedTasks';
import BinderValidation from 'pages/binder/containers/BinderValidation';

import ProcessContainer from 'processflow/containers/ProcessContainer/ProcessContainer';

import IndexDocument from 'indexDocuments/containers/IndexDocument/IndexDocument';
import DocumentPermission from 'indexDocuments/containers/DocumentPermission/DocumentPermission';

import FormSelector from 'forms/containers/FormSelector/FormSelector';
// import Sentbox from 'workflow/containers/Sentbox';
import Reports from '../pages/report/containers/Report';
import ReportContent from '../pages/report/containers/ReportContent';
import Events from 'pages/events/containers/Events';
import CreateStudy from 'pages/study/containers/CreateStudy';
import StudyContainer from 'pages/studyOverview/containers/StudyContainer/StudyContainer.js';
import StudyOverview from 'pages/studyOverview/containers/StudyOverview/StudyOverview.js';
import StudyDocuments from 'pages/studyOverview/containers/StudyDocuments/StudyDocuments.js';
import StudyExpectations from 'pages/studyOverview/containers/StudyExpectations/StudyExpectations.js';
import StudyUsers from '../pages/studyOverview/containers/StudyUsers/StudyUsers';
import StudyUsersTeam from '../pages/studyOverview/containers/StudyUsers/StudyUsersTeam';
import StudyUsersMonitors from '../pages/studyOverview/containers/StudyUsers/StudyUsersMonitors';
import StudyExpectationsAllDocuments from 'pages/studyOverview/containers/StudyExpectations/StudyExpectationsAllDocuments.js';
import StudyExpectationsMissingDocuments from 'pages/studyOverview/containers/StudyExpectations/StudyExpectationsMissingDocuments.js';
import StudyExpectationsStaffDocuments from 'pages/studyOverview/containers/StudyExpectations/ContentBody/StaffDocuments.js';
import StudyExpectationsStudyDocuments from 'pages/studyOverview/containers/StudyExpectations/ContentBody/StudyDocuments.js';
import StudySettings from 'pages/studyOverview/containers/StudySettings/StudySettings.js';
import StudySettingsDetails from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsDetails.js';
import StudySettingsEssentials from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsDetailsV4.js';
// import StudySettingsStudy from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsStudy.js';
import StudySettingsMonitors from 'pages/studyOverview/containers/StudySettings/Settings/StudyMonitors';
import StudySettingsTeamV2 from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsTeamV2.js';
import StudySettingsExpectations from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsExpectations.js';
import StudySettingsExpectationsStaff from 'pages/studyOverview/containers/StudySettings/Settings/ExpectationsContent/Staff.js';
import StudySettingsExpectationsStudy from 'pages/studyOverview/containers/StudySettings/Settings/ExpectationsContent/Study.js';
import StudyTasks from 'pages/studyOverview/containers/StudyTasks/StudyTasks.js';
import DefaultStudyRouteRedirect from 'pages/studyOverview/containers/StudyContainer/DefaultStudyRoute.js';

import EventsConfiguration from 'common/containers/Events/InstitutionalAdminEventsConfiguration';
import CreateEventType from 'common/containers/Events/CreateEventType/InstitutionalAdminCreateEventType';
import EditEventType from 'common/containers/Events/EditEventType/InstitutionalAdminEditEventType';
import StudyBasicInformation from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsBasicInformation.js';

import {
    ForAuthenticatedUsers,
    ForInstitutionalAdmins,
    ForUsersWhoCreateBinders,
    ForUsersWhoCanEditBinderDetails,
    ForUsersWhoCanAccessBinderTask,
    ForUsersWithAccessToBinder,
    ForUsersWithSpecificFilePermissions,
    ForUsersThatCanManageInternalUserAccess,
    ForUsersThatCanManageExternalUserAccess,
    ForUsersThatCanCompileBinders,
    ForUsersWhoCanEditBinderQuery,
    ForUsersThatCanSeeBinderTimeline,
    ForUsersThatCanViewDataSources,
    AlwaysRedirectHome,
    ForUsersAtInstitutionsWithDoA,
    StudyDoaFeatureAccess,
    ForUsersWithStudyFeatureAccess,
    ForUsersWithViewStudyExpectationAccess,
    ForUsersWithManageStudyExpectationsAccess,
    ForUsersWithBinderValidationFeatureAccess,
    ForUsersThatCanViewReport,
    ForUsersAtInstitutionsWithBinderEvents,
    ForUsersWithStudyEventFeatureAccess,
    ForUsersWithManageEventTypes,
    ForUsersWhoCreateStudies,
    ForUsersWithViewStudyDashboardAccess,
    ForUsersWithManageTasksAccess,
    ForUsersWithV4FeatureAccess,
} from 'common/permissions/routes/main';

import { ForUsersWithViewUsersPermission, ForUsersWithViewStudyMonitorsPermission, ForUsersWithViewStudyTeamPermission, ForUsersWithViewStudyMetadataAccess, ForUsersWithViewStudySettingsAccess } from 'common/permissions/routes/permissions';
import { UserCanManageStudyPermissions } from 'common/permissions/components/tabs';
import RestrictedContainer from 'common/permissions/components/RestrictedContainer';
import DefaultStudySettingsRouteRedirect from '../pages/studyOverview/containers/StudySettings/Settings/DefaultSettingsRoute';
import Tasks from '../overview/containers/BindersV4/Tasks';
import StudyBinders from '../overview/containers/BindersV4/StudyBinders';
import AdministrativeBinders from '../overview/containers/BindersV4/AdministrativeBinders';
import HomePageV4 from '../overview/containers/HomePageV4/HomePageV4';
import BindersV4 from '../overview/containers/BindersV4/BindersV4';
import ResetPassword from '../common/components/Login/ResetPassword';
import ForgotPassword from '../common/components/Login/ForgotPassword';
import NewUser from '../common/components/Login/NewUser';

import ReportDownload from '../pages/report/containers/ReportDownload';
import ExpiredPassword from '../common/components/Login/ExpiredPassword';

// This component is just used for development
class Dummy extends Component {
    render() {
        return (
            <div>
                This is a placeholder
            </div>
        );
    }
}

export default (
    <Route path="/" component={AppContainer}>
        <Route exact path={'reset-password'} component={ResetPassword} />
        <Route exact path={'expired-password'} component={ExpiredPassword} />
        <Route exact path={'forgot-password'} component={ForgotPassword} />
        <Route exact path={'reset-password'} component={ResetPassword} />
        <Route exact path={'new-user'} component={NewUser} />
        <Route exact path="newUser" component={UserRegistration} />
        <Route component={RestrictedContainer}>
            {/* <Route component={ForAuthenticatedUsers(Overview)}>
                <Route path="dashboard" component={ForUsersAtInstitutionsWithDashboard(Dashboard)} />
                <Route path="studies" component={ForUsersWithStudyFeatureAccess(StudyListPage)} />
                <Route path="binders" component={Binders} />
                <Route path="sent" component={SentboxV2}>
                    <IndexRedirect to="/sent/incomplete" />
                    <Route path="incomplete" component={PendingSentbox} />
                    <Route path="completed" component={CompletedSentbox} />
                </Route>
                <Route name="Inbox" path="inbox" component={Inbox} >
                    <IndexRedirect to="/new-inbox" />
                </Route>
                <Route name="NewInbox" path="new-inbox" component={ForUsersWithNewInboxFeatureAccess(NewInbox)} />
                <Route path="download" component={ReportDownload} />
            </Route> */}
            <Route component={ForAuthenticatedUsers(HomePageV4)}>
                <Route exact path={'reset-password'} component={ResetPassword} />
                <Route path="binders" component={BindersV4} >
                    <IndexRedirect to="study" />
                    <Route path="study" component={StudyBinders} />
                    <Route path="study/draft/:draftBinderId" component={StudyBinders} />
                    <Route path="administrative" component={AdministrativeBinders} />
                    <Route path="administrative/draft/:draftBinderId" component={AdministrativeBinders} />
                </Route>
                <Route path="tasks" component={ForUsersWithV4FeatureAccess(Tasks)}>
                    <IndexRedirect to="my-tasks/open" />
                    <Route path="my-tasks">
                        <IndexRedirect to="open" />
                        <Route path="open" component={Tasks} />
                        <Route path="completed" component={Tasks} />
                    </Route>
                    <Route path="sent-tasks">
                        <IndexRedirect to="open" />
                        <Route path="open" component={Tasks} />
                        <Route path="completed" component={Tasks} />
                    </Route>
                </Route>
                <Route path="download" component={ReportDownload} />
            </Route>
            <Route path="study">
                <Route path="create" component={ForUsersWithStudyFeatureAccess(CreateStudy)} />
                <Route path="draft" component={ForUsersWithStudyFeatureAccess(CreateStudy)} />
                <Route path=":id" component={ForUsersWithStudyFeatureAccess(StudyContainer)}>
                    <IndexRoute component={DefaultStudyRouteRedirect} />
                    <Route path="files/:documentId/sign" component={ForAuthenticatedUsers(DocumentSigning)} />
                    <Route path="files/:documentId/:indexingType"
                        component={props =>
                            <DocumentPermission {...props} isFromStudy={true}>
                                <IndexDocument key="indexDocument" />
                            </DocumentPermission>}
                    />

                    <Route path="files/:documentId" component={ForAuthenticatedUsers(DocumentView)} />

                    <Route path='dashboard' component={ForUsersWithViewStudyDashboardAccess(StudyOverview)} />
                    <Route path='tasks' component={ForUsersWithManageTasksAccess(StudyTasks)}>
                        <IndexRedirect to="/study/:id/tasks/pending" />
                        <Route path="pending" component={StudyTasks} />
                        <Route path="completed" component={StudyTasks} />
                    </Route>
                    <Route path='expectations' component={ForUsersWithViewStudyExpectationAccess(StudyExpectations)}>
                        <IndexRedirect to="/study/:id/expectations/all-documents/study" />
                        <Route path='all-documents' component={(StudyExpectationsAllDocuments)} >
                            <IndexRedirect to="/study/:id/expectations/all-documents/study" />
                            <Route path='study' component={(StudyExpectationsStudyDocuments)} />
                            <Route path='staff' component={(StudyExpectationsStaffDocuments)} />
                        </Route>
                        <Route path='missing-documents' component={(StudyExpectationsMissingDocuments)} >
                            <IndexRedirect to="/study/:id/expectations/missing-documents/study" />
                            <Route path='study' component={(StudyExpectationsStudyDocuments)} />
                            <Route path='staff' component={(StudyExpectationsStaffDocuments)} />
                        </Route>
                    </Route>
                    <Route path='events' component={ForUsersWithStudyEventFeatureAccess(Events)} />
                    <Route path='users' component={ForUsersWithViewUsersPermission(StudyUsers)}>
                        <Route path="team" component={ForUsersWithViewStudyTeamPermission(StudyUsersTeam)} />
                        <Route path="monitors" component={ForUsersWithViewStudyMonitorsPermission(StudyUsersMonitors)} />
                    </Route>
                    <Route path='delegation' component={StudyDoaFeatureAccess(DelegationOfAuthorityV2)} />
                    <Route path='documents' component={(StudyDocuments)} />
                    <Route path='settings' component={ForUsersWithViewStudySettingsAccess(StudySettings)}>
                        <IndexRoute component={DefaultStudySettingsRouteRedirect} />
                        <Route path="study" component={ForUsersWithViewStudyMetadataAccess(StudyBasicInformation)} />
                        <Route path="monitors" component={ForUsersWithViewStudyMonitorsPermission(StudySettingsMonitors)} />
                        <Route path="team" component={ForUsersWithViewStudyTeamPermission(StudySettingsTeamV2)} />
                        <Route path="details" component={ForUsersWithViewStudyMetadataAccess(StudySettingsEssentials)} />
                        <Route path="setup" component={ForUsersWithViewStudyMetadataAccess(StudySettingsDetails)} />
                        <Route path="expectations" component={ForUsersWithManageStudyExpectationsAccess(StudySettingsExpectations)}>
                            <IndexRedirect to="/study/:id/settings/expectations/study-documents" />
                            <Route path='study-documents' component={StudySettingsExpectationsStudy} />
                            <Route path='staff-documents' component={StudySettingsExpectationsStaff} />
                        </Route>
                    </Route>
                </Route>
            </Route>
            <Route path="create-binder" component={ForUsersWhoCreateBinders(CreateBinder)} />
            <Route path="binder" component={ForAuthenticatedUsers(BinderView)}>
                <IndexRedirect to="/binders" />
                <Route path=":id" component={ForUsersWithAccessToBinder(Binder)}>
                    <IndexRoute component={Details} />
                    <Route path="edit" component={ForUsersWhoCanEditBinderDetails(CreateBinder)} />
                    <Route path="files" component={ForUsersWithSpecificFilePermissions(Files)} />
                    <Route path="setup" component={BinderSetup} />
                    <Route path="configure" component={ForUsersWhoCanEditBinderQuery(Dummy)} />
                    <Route path="sent" component={Dummy} />
                    <Route path="inbox" component={Dummy} />
                    <Route path="users" component={ForUsersThatCanManageInternalUserAccess(UsersConfiguration)} />
                    <Route path="externalUsers" component={ForUsersThatCanManageExternalUserAccess(ExternalUsers)} />
                    <Route path="compile" component={ForUsersThatCanCompileBinders(Dummy)} />
                    <Route path="timeline" component={ForUsersThatCanSeeBinderTimeline(Dummy)} />
                    <Route path="delegation" component={ForUsersAtInstitutionsWithDoA(DelegationOfAuthorityV2)} />
                    <Route path="delegation-v2" component={ForUsersAtInstitutionsWithDoA(DelegationOfAuthorityV2)} />
                    <Route path="validation" component={ForUsersWithBinderValidationFeatureAccess(BinderValidation)} />
                    <Route path="files/:documentId/sign" component={ForAuthenticatedUsers(DocumentSigning)} />
                    <Route path="files/:documentId/:indexingType"
                        component={props =>
                            <DocumentPermission {...props}>
                                <IndexDocument key="indexDocument" />
                            </DocumentPermission>}
                    />
                    {/* <Route path="tasks" component={ForUsersWhoCanAccessBinderTask(BinderTask)}>
                        <Route path="pending" component={BinderTask} />
                        <Route path="completed" component={BinderTask} /> */}
                    <Route path="tasks" component={ForUsersWhoCanAccessBinderTask(BinderTaskV2)}>
                        <IndexRedirect to="/binder/:id/tasks/incomplete" />
                        <Route path="incomplete" component={IncompleteTasks} />
                        <Route path="completed" component={CompletedTasks} />
                    </Route>
                    <Route path="events" component={ForUsersAtInstitutionsWithBinderEvents(Events)} />
                </Route>
            </Route>
            <Route path="form/:source/:id" component={ForAuthenticatedUsers(FormSelector)} />
        </Route>
        <Route component={DeprecatedStylesContainer}>
            <Route component={RestrictedContainer}>
                <Route path="registration" component={ForAuthenticatedUsers(ProcessContainer)} />
                <Route path="binder/:id/files">
                    <Route path=":documentId" component={ForAuthenticatedUsers(DocumentView)} />
                </Route>
                <Route path="admin" component={ForInstitutionalAdmins(InstitutionalAdminOverview)}>
                    <Route path="users" component={Users} />
                    <Route path="users/create" component={CreateUser} />
                    <Route path="users/:userId" component={User} />
                    <Route path="users/:userId/edit" component={CreateUser} />
                    <Route path="groups" component={Groups} />
                    <Route path="role" component={ForUsersWhoCreateStudies(RoleManagement)}>
                        <IndexRedirect to="/admin/role/study-role" />
                        <Route path="study-role" component={RoleContent} />
                    </Route>
                    <Route path="permissions" component={UserCanManageStudyPermissions(ForUsersWithStudyFeatureAccess(Permissions))}>
                        <IndexRedirect to="/admin/permissions/study" />
                        <Route path="study" component={StudyPermissions} />
                    </Route>
                    <Route path="groups/:groupId" component={Group} />
                    <Route path="datasources" component={ForUsersThatCanViewDataSources(DataSourceList)} />
                    <Route path="datasources/:dataSourceId" component={ForUsersThatCanViewDataSources(DataSourceManagement)} />
                    <Route path="report" component={ForUsersThatCanViewReport(Reports)}>
                        <IndexRedirect to="/admin/report/binders" />
                        <Route path="binders" component={ReportContent} />
                        <Route path="documents" component={ReportContent} />
                        <Route path="tasks" component={ReportContent} />
                        <Route path="expiring-documents" component={ReportContent} />
                        <Route path="unfiled-documents" component={ReportContent} />
                        <Route path="user-document-audit-trail" component={ReportContent} />
                        <Route path="billable-history" component={ReportContent} />
                    </Route>
                    <Route path="events" component={ForUsersWithManageEventTypes(EventsConfiguration)} />
                    <Route path="events/create" component={ForUsersWithManageEventTypes(CreateEventType)} />
                    <Route path="events/edit/:eventTypeId" component={ForUsersWithManageEventTypes(EditEventType)} />
                </Route>

                <Route path="query/documents" component={ForAuthenticatedUsers(QueryFiles)} />
            </Route>
        </Route>

        <Route path="logout" onEnter={() => {
            const { logoutLandingPage } = getAuthCredentials();
            SessionTunnel.logout(logoutLandingPage);
        }}
        />
        <Route path="*" component={AlwaysRedirectHome(<div>redirecting...</div>)} />
    </Route>
);
